import { render, staticRenderFns } from "./Illnesses.vue?vue&type=template&id=1fc1d3b0&"
import script from "./Illnesses.vue?vue&type=script&lang=js&"
export * from "./Illnesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports